import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class ModeloRdService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
        this.urlBase = `${SCAMP_API.accountApiV1}/rd-modelos`;
    }
    add(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/rd-modelos`, data, { headers: this.account.composeHeaders() });
    }
    getById(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/rd-modelos/${id}`, { headers: this.account.composeHeaders() });
    }
    getAll() {
        return this.http.get(`${SCAMP_API.accountApiV1}/rd-modelos`, { headers: this.account.composeHeaders() });
    }
    getAllPromise() {
        return fetch(this.urlBase, {
            method: 'GET',
            headers: this.account.getHearderAuthorization()
        });
    }
    deleteById(id) {
        return this.http.delete(`${SCAMP_API.accountApiV1}/rd-modelos/${id}`, { headers: this.account.composeHeaders() });
    }
    isUniqueNome(nome, id) {
        return this.http.post(`${SCAMP_API.accountApiV1}/rd-modelos/is-unique-nome`, { nome, id }, { headers: this.account.composeHeaders() });
    }
    isUniquePrefixo(prefixo, id) {
        return this.http.post(`${SCAMP_API.accountApiV1}/rd-modelos/is-unique-prefixo`, { prefixo, id }, { headers: this.account.composeHeaders() });
    }
}
ModeloRdService.ngInjectableDef = i0.defineInjectable({ factory: function ModeloRdService_Factory() { return new ModeloRdService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: ModeloRdService, providedIn: "root" });
